"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Practice API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmartActionTemplateActionTypeToJSON = exports.SmartActionTemplateActionTypeFromJSONTyped = exports.SmartActionTemplateActionTypeFromJSON = exports.SmartActionTemplateActionType = void 0;
/**
 *
 * @export
 * @enum {string}
 */
var SmartActionTemplateActionType;
(function (SmartActionTemplateActionType) {
    SmartActionTemplateActionType["AddLabel"] = "add-label";
    SmartActionTemplateActionType["SendForm"] = "send-form";
    SmartActionTemplateActionType["SendFormWithSignedContract"] = "send-form-with-signed-contract";
    SmartActionTemplateActionType["ShowForm"] = "show-form";
    SmartActionTemplateActionType["SendReminder"] = "send-reminder";
    SmartActionTemplateActionType["SendLibraryItem"] = "send-library-item";
    SmartActionTemplateActionType["SendInvoice"] = "send-invoice";
    SmartActionTemplateActionType["BillScheduledInvoice"] = "bill-scheduled-invoice";
    SmartActionTemplateActionType["SendBillInvoiceNotification"] = "send-bill-invoice-notification";
    SmartActionTemplateActionType["SendInvoiceReminderCoach"] = "send-invoice-reminder-coach";
    SmartActionTemplateActionType["SendInvoiceReminderClient"] = "send-invoice-reminder-client";
    SmartActionTemplateActionType["SendTrialWillEndReminder"] = "send-trial-will-end-reminder";
    SmartActionTemplateActionType["TodoAssignmentReminder"] = "todo-assignment-reminder";
    SmartActionTemplateActionType["TodoDueDateReminder"] = "todo-due-date-reminder";
    SmartActionTemplateActionType["TodoWeekReminder"] = "todo-week-reminder";
    SmartActionTemplateActionType["RecurringPackageInstance"] = "recurring-package-instance";
    SmartActionTemplateActionType["CompletePackageInstance"] = "complete-package-instance";
    SmartActionTemplateActionType["CreateBillableRequest"] = "create-billable-request";
    SmartActionTemplateActionType["RolloverPendingTransactions"] = "rollover-pending-transactions";
    SmartActionTemplateActionType["AddBillingTransactionToApInvoice"] = "add-billing-transaction-to-ap-invoice";
    SmartActionTemplateActionType["AddBillingTransactionToUbpInvoice"] = "add-billing-transaction-to-ubp-invoice";
    SmartActionTemplateActionType["RecomputeBillingTransaction"] = "recompute-billing-transaction";
    SmartActionTemplateActionType["CollectPackagePayment"] = "collect-package-payment";
    SmartActionTemplateActionType["SendFormReminder"] = "send-form-reminder";
    SmartActionTemplateActionType["SendPackageTrackingNotification"] = "send-package-tracking-notification";
    SmartActionTemplateActionType["CheckPackageTrackingStatus"] = "check-package-tracking-status";
    SmartActionTemplateActionType["SyncInvoice"] = "sync-invoice";
    SmartActionTemplateActionType["SyncSubscription"] = "sync-subscription";
    SmartActionTemplateActionType["CreatePackageInstanceSubscription"] = "create-package-instance-subscription";
    SmartActionTemplateActionType["ExpirePackageInstance"] = "expire-package-instance";
    SmartActionTemplateActionType["CallEndpoint"] = "call-endpoint";
    SmartActionTemplateActionType["ActivatePackageInstance"] = "activate-package-instance";
    SmartActionTemplateActionType["SyncInvoiceWithQuickBooks"] = "sync-invoice-with-quick-books";
    SmartActionTemplateActionType["UpdatePackageInstanceTier"] = "update-package-instance-tier";
})(SmartActionTemplateActionType || (exports.SmartActionTemplateActionType = SmartActionTemplateActionType = {}));
function SmartActionTemplateActionTypeFromJSON(json) {
    return SmartActionTemplateActionTypeFromJSONTyped(json, false);
}
exports.SmartActionTemplateActionTypeFromJSON = SmartActionTemplateActionTypeFromJSON;
function SmartActionTemplateActionTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.SmartActionTemplateActionTypeFromJSONTyped = SmartActionTemplateActionTypeFromJSONTyped;
function SmartActionTemplateActionTypeToJSON(value) {
    return value;
}
exports.SmartActionTemplateActionTypeToJSON = SmartActionTemplateActionTypeToJSON;
//# sourceMappingURL=SmartActionTemplateActionType.js.map